var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./shimmer.module.css";
export var Shimmer = function (_a) {
    var _b;
    var className = _a.className, _c = _a.active, active = _c === void 0 ? true : _c, _d = _a.width, width = _d === void 0 ? "" : _d, _e = _a.height, height = _e === void 0 ? "" : _e, _f = _a.relative, relative = _f === void 0 ? false : _f, _g = _a.circle, circle = _g === void 0 ? false : _g, _h = _a.borderRadius, borderRadius = _h === void 0 ? "3px" : _h, rest = __rest(_a, ["className", "active", "width", "height", "relative", "circle", "borderRadius"]);
    return (_jsx("div", { className: classNames(styles["shimmer"], className, (_b = {},
            _b[styles["active"]] = active,
            _b[styles["circle"]] = circle,
            _b)), style: {
            width: relative ? width : "100%",
            height: relative ? height : "100%",
            position: relative ? "relative" : "absolute",
            borderRadius: borderRadius,
        }, children: _jsx("div", { className: styles["shine"] }) }));
};
